import { Button, ButtonProps, ButtonType } from '@ardoq/button';
import { ICON_BADGE_ICON_SELECTOR, IconBadge } from './IconBadge';
import { IconName, IconProps } from '@ardoq/icons';
import { StatusType } from '../types';
import styled from 'styled-components';
import { omit } from 'lodash';

const ButtonStyledIconBadge = styled(IconBadge)`
  ${ICON_BADGE_ICON_SELECTOR} {
    /* Icon buttons should be exactly square */
    margin: 0 5px;
  }
`;

export type IconBadgeButtonProps = ButtonProps & {
  iconName: IconName;
  iconColor?: IconProps['color'];
  statusType: StatusType;
};

export const IconBadgeButton = ({
  iconName,
  iconColor,
  statusType,
  ...buttonProps
}: IconBadgeButtonProps) => (
  <Button buttonType={ButtonType.GHOST} {...omit(buttonProps, 'buttonType')}>
    <ButtonStyledIconBadge
      statusType={statusType}
      color={iconColor}
      iconName={iconName}
    />
  </Button>
);
